// @ts-check
import React, { Component } from "react"
import { BlockContextConsumer } from "../ContextProviders"
import DefineBroadcast from "../broadcast/DefineBroadcast"
import { generateId } from "../broadcast/utils"

/**
 * @augments {Component<{context: BlockContext} & Broadcast_Validation>}
 */
class DefineValidation extends Component {
    static defaultProps = {
        tags: [],
    }
    componentWillMount() {
        const blockId = this.props.context.block.id

        const { name, description, severity, payload, tags } = this.props

        /**
         * @type {Broadcast_Validation}
         */
        this.validation = {
            id: generateId(blockId, "validation", name),
            ownerBlockId: blockId,
            tags,
            name,
            description,
            channel: "validation",
            severity,
            payload,
        }
    }
    render() {
        return <DefineBroadcast broadcast={this.validation} />
    }
}

DefineValidation.propTypes = {}

export default function DefineValidationInContext(props) {
    return (
        <BlockContextConsumer>
            {context => <DefineValidation {...props} context={context} />}
        </BlockContextConsumer>
    )
}



// WEBPACK FOOTER //
// ./src/features/editor/validation/DefineValidation.js